import React from 'react';
import PropTypes from 'prop-types';
import {generateUrl, routes} from "helpers/routes";
import {Link} from "react-router-dom";

class AdvertLink extends React.Component {
    static propTypes = {
        advert: PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            photoUrl: PropTypes.string,
        }).isRequired,
        active: PropTypes.bool,
        unreadCount: PropTypes.number.isRequired,
    };

    render() {
        const {advert, active, unreadCount} = this.props;

        let classes = "user__item";
        if (active) {
            classes += " user__item--active"
        }

        return (
            <div className={classes}>
                <Link to={generateUrl(routes.conversations, {advert: advert.id})} className="clickable">
                    <img src={advert.photoUrl} alt={advert.name} />
                    {unreadCount > 0 &&
                    <span className="badge badge-secondary">{unreadCount}</span>
                    }
                </Link>
            </div>
        )
    }
}

export default AdvertLink;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Controls/AdvertLink.jsx